<script>
    import * as Icons from 'lucide-svelte';
    import LySection from '../layouts/components/LySection.svelte';
    import LyHeadline from '../layouts/components/LyHeadline.svelte';
    import LyContent from '../layouts/components/LyContent.svelte';
    import LyHeader from '../layouts/components/LyHeader.svelte';
    import LyP from '../layouts/components/LyP.svelte';
    import { PageStore } from '../stores/PageStore.svelte.js';
    import LyButton from '../layouts/forms/LyButton.svelte';
    import LyGrid3 from '../layouts/components/LyGrid3.svelte';
    import LyButtons from '../layouts/forms/LyButtons.svelte';
</script>

<LyContent wrapper={true}>
    <LyHeader>
        <LyHeadline icon={Icons.Utensils}>Helferlein</LyHeadline>
    </LyHeader>

    <LySection tag="div">
        <LyP>Kleinere Tools, die einem das Leben einfacher machen.</LyP>
    </LySection>
</LyContent>

<LyGrid3 wrapper={true} mt={true}>
    <LyContent tag="article" addClass="flex h-full flex-col">
        <LyHeader>
            <LyHeadline weight={2} center={true}>Klartext-Bereinigung</LyHeadline>
        </LyHeader>
        <LyP center={true}>Texte aus KI oder externen Quellen normalisieren.</LyP>
        <div class="mt-auto">
            <LyButtons mt={true} center={true}>
                <LyButton label="Zum Tool" onclick={() => PageStore.set('/strings/normizer')} />
            </LyButtons>
        </div>
    </LyContent>
</LyGrid3>
